// --- Outlet URL helper ---
function mmAppendOutletParam(url, outletContext) {
    if (!outletContext) return url;
    const u = new URL(url, window.location.origin);
    u.searchParams.set('outlet', outletContext);
    return u.toString();
}

// --- Cover image update (desktop hover fade) ---
function mmUpdateCardCover(card, filtered) {
    const coverEl = card.querySelector('[data-card-cover]');
    if (!coverEl || !filtered.length) return;
    const firstSlideImg = filtered[0].querySelector('img');
    const coverImg = coverEl.querySelector('img');
    if (!firstSlideImg || !coverImg) return;
    if (firstSlideImg.src !== coverImg.src) {
        coverImg.src = firstSlideImg.src;
        if (firstSlideImg.srcset) coverImg.srcset = firstSlideImg.srcset;
        else coverImg.removeAttribute('srcset');
    }
}

// --- Global card variant handler ---
window.mmCardVariantClick = function(button, isInit) {
    const card = button.closest('.mm-product-card');
    if (!card) return;

    const variantId = parseInt(button.dataset.variantId);
    if (!variantId) return;

    // Get or init card state
    if (!card._mmState) {
        const dataScript = card.querySelector('.mm-product-data');
        if (!dataScript) return;

        let productData;
        try {
            productData = JSON.parse(dataScript.textContent);
        } catch (e) { return; }

        card._mmState = {
            variantMap: Object.fromEntries(productData.variants.map(v => [v.id, v])),
            variantPositions: productData.variant_positions || {},
            defaultVariantId: productData.default_variant_id,
            preorder: productData.preorder || false,
            selectedVariantId: null,
            allSlides: null,
            currentRange: null
        };
    }

    const state = card._mmState;
    const variant = state.variantMap[variantId];
    if (!variant) return;

    // If already selected → do nothing
    if (state.selectedVariantId === variantId) return;


    state.selectedVariantId = variantId;
    const isColorOOS = button.hasAttribute('data-variant-oos');

    // Update active state on ALL variant buttons in this card
    card.querySelectorAll('[data-variant-id]').forEach(item => {
        item.classList.toggle('is-active', parseInt(item.dataset.variantId) === variantId);
    });

    // Update card link URL (skip on init — keep clean product URL without variant)
    if (!isInit) {
        const colorUrl = new URL(variant.url, window.location.origin);
        colorUrl.searchParams.set('no_size', '1');
        const variantHref = mmAppendOutletParam(colorUrl.toString(), card.dataset.outletContext);

        const cardLink = card.querySelector('.mm-product-card-link');
        if (cardLink) cardLink.href = variantHref;

        const titleLink = card.querySelector('.mm-product-card-content-title-reference');
        if (titleLink && titleLink.tagName === 'A') titleLink.href = variantHref;
    }

    // Update price/tags
    mmUpdateCardPrice(card, variant, state.preorder, isColorOOS);

    const searchMedia = card.querySelector('[data-card-search-media]');
    if (searchMedia) {
        if (variant.featured_image) {
            const img = searchMedia.querySelector('img');
            if (img) {
                img.src = variant.featured_image;
                img.removeAttribute('srcset');
            }
        }
        return;
    }

    mmFilterCardSlider(card, variantId.toString(), isInit);

    // Synchroniser les clones Splide (mode loop) avec la même couleur sélectionnée
    if (!isInit) mmSyncCardClones(card, variantId);
};

// --- Sync des clones Splide loop : même produit, même couleur ---
function mmSyncCardClones(sourceCard, variantId) {
    const productId = sourceCard.dataset.mmProductId;
    if (!productId) return;
    document.querySelectorAll('.mm-product-card[data-mm-product-id="' + productId + '"]').forEach(function(otherCard) {
        if (otherCard === sourceCard) return;
        // Marquer comme initialisé AVANT toute modif DOM pour bloquer le MutationObserver
        otherCard.dataset.cardInit = 'true';
        // Init l'état si le clone n'a pas encore été traité
        if (!otherCard._mmState) {
            const dataScript = otherCard.querySelector('.mm-product-data');
            if (!dataScript) return;
            try {
                const productData = JSON.parse(dataScript.textContent);
                otherCard._mmState = {
                    variantMap: Object.fromEntries(productData.variants.map(function(v) { return [v.id, v]; })),
                    variantPositions: productData.variant_positions || {},
                    defaultVariantId: productData.default_variant_id,
                    preorder: productData.preorder || false,
                    selectedVariantId: null,
                    allSlides: null,
                    currentRange: null
                };
            } catch (e) { return; }
        }
        // Forcer le rebuild avec la nouvelle couleur
        otherCard._mmState.currentRange = null;
        otherCard._mmState.allSlides = null;
        mmFilterCardSlider(otherCard, String(variantId), true);
    });
}

/** Clé variante comme dans le JSON Liquid (toujours string). */
function mmVariantPositionValue(positions, variantId) {
    if (variantId == null || variantId === '') return undefined;
    const s = String(variantId);
    if (Object.prototype.hasOwnProperty.call(positions, s)) return positions[s];
    return undefined;
}

function mmHasVariantPosition(positions, variantId) {
    return mmVariantPositionValue(positions, variantId) !== undefined;
}

// --- Variant OOS check ---
function mmIsVariantOOS(variant) {
    // Truly OOS: not available + inventory tracked + policy != continue
    return !variant.available && variant.inventory_management !== null && variant.inventory_policy !== 'continue';
}

function mmIsVariantPreorder(variant, preorder) {
    // Preorder: OOS + preorder metafield + continue selling
    return !variant.available && preorder && variant.inventory_policy === 'continue';
}

// --- Price UI update ---
function mmUpdateCardPrice(card, variant, preorder, isColorOOS) {
    const priceEl = card.querySelector('.mm-product-prices-price');
    const comparePriceEl = card.querySelector('.mm-product-prices-compare');
    const tagEl = card.querySelector('.mm-card-product-tag-reduce');
    const badgesEl = card.querySelector('.mm-card-product-tag-badges');
    const isOOS = isColorOOS || false;
    const isPreorder = !isOOS && mmIsVariantPreorder(variant, preorder);

    // Handle preorder badge
    let preorderBadge = card.querySelector('.mm-card-product-tag-preorder');
    if (isPreorder) {
        if (!preorderBadge) {
            preorderBadge = document.createElement('span');
            preorderBadge.className = 'mm-card-product-tag-preorder mm-card-product-tag-item mm-card-info';
            preorderBadge.style.cssText = '--tag-background-color: var(--black-900); --tag-text-color: var(--white);';
            preorderBadge.textContent = 'Précommande';
            const tagContainer = card.querySelector('.mm-card-product-tag');
            if (tagContainer) tagContainer.appendChild(preorderBadge);
        }
        preorderBadge.style.display = 'block';
    } else if (preorderBadge) {
        preorderBadge.style.display = 'none';
    }

    if (isOOS) {
        // OOS: show only base price (compare_at if exists, otherwise price), no strikethrough
        if (priceEl) {
            priceEl.textContent = variant.compare_at_price || variant.price;
        }
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (tagEl) tagEl.style.display = 'none';
        if (badgesEl) badgesEl.style.display = 'contents';
    } else {
        // Normal display
        if (priceEl) priceEl.textContent = variant.price;

        if (comparePriceEl) {
            if (variant.compare_at_price_cents > variant.price_cents) {
                comparePriceEl.textContent = variant.compare_at_price;
                comparePriceEl.style.display = 'block';
            } else {
                comparePriceEl.style.display = 'none';
            }
        }

        if (tagEl) {
            const reduce = (variant.compare_at_price_cents && variant.compare_at_price_cents > variant.price_cents)
                ? '-' + Math.round((variant.compare_at_price_cents - variant.price_cents) / variant.compare_at_price_cents * 100) + '%'
                : '';
            if (reduce) {
                tagEl.textContent = reduce;
                tagEl.style.display = 'block';
                if (badgesEl) badgesEl.style.display = 'none';
            } else {
                tagEl.style.display = 'none';
                if (badgesEl) badgesEl.style.display = 'contents';
            }
        }
    }
}

// --- Attend que la 1re image soit chargée avant de fader le snapshot ---
function mmFadeSnapshot(snapshot, sliderEl) {
    const doFade = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                snapshot.style.transition = 'opacity 0.4s ease';
                snapshot.style.opacity = '0';
            });
        });
    };
    const firstImg = sliderEl.querySelector('.splide__slide img');
    if (!firstImg || (firstImg.complete && firstImg.naturalWidth > 0)) {
        doFade();
    } else {
        const timeout = setTimeout(doFade, 1200);
        firstImg.addEventListener('load', () => { clearTimeout(timeout); doFade(); }, { once: true });
        firstImg.addEventListener('error', () => { clearTimeout(timeout); doFade(); }, { once: true });
    }
}

// --- Slider filtering ---
function mmFilterCardSlider(card, variantId, isInit) {
    const state = card._mmState;
    if (!state) return;

    const sliderEl = card.querySelector('[data-card-slider]');
    if (!sliderEl) return;

    // Store original slides on first call
    if (!state.allSlides) {
        const list = sliderEl.querySelector('[data-card-slider-list]');
        if (list) {
            state.allSlides = Array.from(list.children).map(el => el.cloneNode(true));
        }
    }
    if (!state.allSlides || state.allSlides.length === 0) {
        if (window.SplideManager && typeof window.SplideManager._initOne === 'function') {
            window.SplideManager._initOne(sliderEl, []);
        }
        return;
    }

    // Calculate range
    const positions = state.variantPositions;
    const posValues = Object.values(positions);
    if (posValues.length === 0) {
        if (window.SplideManager && typeof window.SplideManager._initOne === 'function') {
            window.SplideManager._initOne(sliderEl, []);
        }
        return;
    }

    let variantPos = mmVariantPositionValue(positions, variantId);
    // Fallback : recherche prédictive / produits où la 1re couleur (best_variant) n’a pas d’entrée
    // dans variant_positions (ex. featured_image non aligné sur product.images côté Liquid) → sinon
    // sortie immédiate = Splide jamais monté = images invisibles.
    if (variantPos === undefined) {
        // Fallback 1: lire la position depuis data-image-position du bouton
        const btn = card.querySelector('[data-variant-id="' + variantId + '"]');
        const imgPos = btn && btn.hasAttribute('data-image-position') ? parseInt(btn.dataset.imagePosition, 10) : NaN;
        if (!isNaN(imgPos)) {
            variantPos = imgPos;
        } else {
            // Pas d'images associées à cette couleur → afficher toutes les images du produit
            const rangeKey = 'all';
            if (state.currentRange === rangeKey) return;
            state.currentRange = rangeKey;
            const filtered = state.allSlides.slice();
            if (!filtered.length) return;
            const sliderSlidesAll = filtered.slice(1);
            const showArrows = sliderSlidesAll.length > 1;
            const rebuildAll = () => {
                if (sliderEl._splide) { try { sliderEl._splide.destroy(); } catch (e) {} sliderEl._splide = null; }
                mmUpdateCardCover(card, filtered);
                card.toggleAttribute('data-single-image', sliderSlidesAll.length === 0);
                if (sliderSlidesAll.length === 0) return;
                const list = sliderEl.querySelector('[data-card-slider-list]');
                list.innerHTML = '';
                sliderSlidesAll.forEach((slide, i) => { const el = slide.cloneNode(true); el.setAttribute('data-media-position', i); list.appendChild(el); });
                const pBar = sliderEl.querySelector('.splide__progress__bar');
                if (pBar) pBar.style.width = '0%';
                try {
                    const instance = new Splide(sliderEl, { type: 'slide', arrows: showArrows, pagination: false, perPage: 1, drag: true });
                    instance.mount();
                    sliderEl._splide = instance;
                    const progressBar = sliderEl.querySelector('.splide__progress__bar');
                    if (progressBar) {
                        const up = () => { try { const end = instance.Components.Controller.getEnd() + 1; progressBar.style.width = String(100 * Math.min((instance.index + 1) / end, 1)) + '%'; } catch (e) {} };
                        instance.on('mounted ready', up);
                        instance.on('move moved', up);
                        requestAnimationFrame(() => setTimeout(up, 50));
                    }
                } catch (e) {}
            };
            if (isInit) { rebuildAll(); return; }
            const track = sliderEl.querySelector('.splide__track');
            const snapshot = track.cloneNode(true);
            snapshot.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:0;pointer-events:none;';
            const clonedList = snapshot.querySelector('.splide__list');
            if (clonedList) clonedList.style.transform = 'none';
            sliderEl.appendChild(snapshot);
            rebuildAll();
            mmFadeSnapshot(snapshot, sliderEl);
            snapshot.addEventListener('transitionend', () => snapshot.remove());
            return;
        }
    }

    const boundaries = [...new Set(posValues)].sort((a, b) => a - b);
    const startIdx = variantPos;
    const nextBoundary = boundaries.find(b => b > variantPos);
    const endIdx = nextBoundary !== undefined ? nextBoundary : state.allSlides.length;

    const rangeKey = `${startIdx}-${endIdx}`;
    if (state.currentRange === rangeKey) return;
    state.currentRange = rangeKey;

    let filtered = state.allSlides.slice(startIdx, endIdx);
    if (!filtered.length) {
        filtered = state.allSlides.slice();
    }
    if (!filtered.length) {
        if (window.SplideManager && typeof window.SplideManager._initOne === 'function') {
            window.SplideManager._initOne(sliderEl, []);
        }
        return;
    }
    const sliderSlides = filtered.slice(1);
    const showArrows = sliderSlides.length > 1;

    const rebuildSlider = () => {
        // Destroy existing Splide
        if (sliderEl._splide) {
            try { sliderEl._splide.destroy(); } catch (e) {}
            sliderEl._splide = null;
        }

        mmUpdateCardCover(card, filtered);
        card.toggleAttribute('data-single-image', sliderSlides.length === 0);
        if (sliderSlides.length === 0) return;

        // Replace slides (2nd image onwards — 1st handled by cover)
        const list = sliderEl.querySelector('[data-card-slider-list]');
        list.innerHTML = '';
        sliderSlides.forEach((slide, i) => {
            const el = slide.cloneNode(true);
            el.setAttribute('data-media-position', i);
            list.appendChild(el);
        });

        // Reset progress bar
        const pBar = sliderEl.querySelector('.splide__progress__bar');
        if (pBar) pBar.style.width = '0%';

        // Re-mount Splide
        try {
            const instance = new Splide(sliderEl, {
                type: 'slide',
                arrows: showArrows,
                pagination: false,
                perPage: 1,
                drag: true
            });
            instance.mount();
            sliderEl._splide = instance;

            // Progress bar (same logic as SplideManager)
            const progressBar = sliderEl.querySelector('.splide__progress__bar');
            if (progressBar) {
                const updateProgress = function() {
                    try {
                        const end = instance.Components.Controller.getEnd() + 1;
                        const rate = Math.min((instance.index + 1) / end, 1);
                        progressBar.style.width = String(100 * rate) + '%';
                    } catch (e) {}
                };
                instance.on('mounted ready', updateProgress);
                instance.on('move moved', updateProgress);
                requestAnimationFrame(() => setTimeout(updateProgress, 50));
            }
        } catch (e) {}
    };

    if (isInit) {
        rebuildSlider();
        return;
    }

    // Capture current track as snapshot (stays visible during transition)
    const track = sliderEl.querySelector('.splide__track');
    const snapshot = track.cloneNode(true);
    snapshot.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:0;pointer-events:none;';
    // Remove any splide transforms on the cloned list
    const clonedList = snapshot.querySelector('.splide__list');
    if (clonedList) clonedList.style.transform = 'none';
    sliderEl.appendChild(snapshot);

    // Rebuild slider underneath (invisible behind snapshot)
    rebuildSlider();

    // Fade out snapshot only once the new image is ready
    mmFadeSnapshot(snapshot, sliderEl);
    snapshot.addEventListener('transitionend', () => snapshot.remove());
}

// --- Init: filter to default variant + mark first variant active ---
const initProductCards = () => {
    document.querySelectorAll('.mm-product-card:not([data-card-init])').forEach(card => {
        card.dataset.cardInit = 'true';

        const dataScript = card.querySelector('.mm-product-data');
        if (!dataScript) return;

        let productData;
        try {
            productData = JSON.parse(dataScript.textContent);
        } catch (e) { return; }

        const variantPositions = productData.variant_positions || {};
        const defaultVariantId = productData.default_variant_id;
        const hasPositions = Object.keys(variantPositions).length > 0;

        const firstVisibleBtn = card.querySelector('[data-variant-id]');
        const firstVariantKey =
            firstVisibleBtn && firstVisibleBtn.dataset.variantId
                ? String(firstVisibleBtn.dataset.variantId)
                : defaultVariantId != null
                  ? String(defaultVariantId)
                  : null;
        const firstVariantNum = firstVariantKey != null ? Number(firstVariantKey) : null;

        // Store state
        card._mmState = {
            variantMap: Object.fromEntries(productData.variants.map(v => [v.id, v])),
            variantPositions,
            defaultVariantId,
            preorder: productData.preorder || false,
            selectedVariantId: firstVariantNum,
            allSlides: null,
            currentRange: null
        };

        // Stocker l'ID produit pour identifier les clones Splide (mode loop)
        card.dataset.mmProductId = String(productData.id);

        // Card click → navigate to product page
        card.addEventListener('click', (e) => {
            if (e.target.closest('[data-variant-id], .splide__arrow')) return;
            const cardLink = card.querySelector('.mm-product-card-link');
            if (!cardLink) return;
            const href = mmAppendOutletParam(cardLink.href, card.dataset.outletContext);
            window.location.href = href;
        });

        // Desktop hover leave → cover fades in first, then slider resets underneath
        card.addEventListener('mouseleave', () => {
            if (window.innerWidth <= 768) return;
            const sliderEl = card.querySelector('[data-card-slider]');
            if (!sliderEl || !sliderEl._splide) return;
            const coverEl = card.querySelector('[data-card-cover]');
            if (coverEl) {
                coverEl.addEventListener('transitionend', (e) => {
                    if (e.propertyName !== 'opacity') return;
                    if (!card.matches(':hover') && sliderEl._splide) sliderEl._splide.go(0);
                }, { once: true });
            } else {
                sliderEl._splide.go(0);
            }
        });

        if (firstVariantKey) {
            // Reset selectedVariantId so mmCardVariantClick runs fully
            card._mmState.selectedVariantId = null;
            const firstBtn = card.querySelector('[data-variant-id="' + firstVariantKey + '"]');
            if (firstBtn) {
                window.mmCardVariantClick(firstBtn, true);
            }
        }
    });
};

document.addEventListener('DOMContentLoaded', initProductCards);

const mmCardObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
        if (mutation.addedNodes.length) { initProductCards(); break; }
    }
});
mmCardObserver.observe(document.body, { childList: true, subtree: true });

